import styled, { css } from 'styled-components';
import {
  aiPanelShadow,
  CHAT_WIDTH,
  colors,
  fontFamily,
  PANEL_GAP,
  SIDEBAR_WIDTH
} from './Utils/tokens';

export const Scrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 998;
  background-color: ${colors.overlay};
`;

export const Panel = styled.div<{
  $open: boolean;
  $sidebarOpen: boolean;
  $expanded: boolean;
}>`
  position: fixed;
  top: ${PANEL_GAP}px;
  right: ${PANEL_GAP}px;
  bottom: ${PANEL_GAP}px;
  z-index: 999;
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  align-items: stretch;
  width: ${({ $sidebarOpen }) =>
    $sidebarOpen ? SIDEBAR_WIDTH + CHAT_WIDTH : CHAT_WIDTH}px;
  max-width: calc(100vw - ${PANEL_GAP * 2}px);
  overflow: hidden;
  border: 1px solid ${colors.surfaceOutline};
  border-radius: 12px;
  background-color: ${colors.surfaceContainer};
  box-shadow: ${aiPanelShadow};
  font-family: ${fontFamily};
  color: ${colors.onSurface};
  transition: width 0.2s ease;

  ${({ $expanded }) =>
    $expanded &&
    css`
      left: ${PANEL_GAP}px;
      width: auto;
    `}

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  min-width: 0;
  height: 100%;
`;

export const ChatArea = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  border: 1px solid ${colors.surfaceOutline};
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  background-color: ${colors.surface};
`;
